import appConfigCoverGoUat from "./appConfigCoverGoUat"
import appConfigCoverGoProd from "./appConfigCoverGoProd"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const yallacompare = {
	// CoverGo PROD
	"yallacompare-uat-studio.quote.hk": {
		appConfig: appConfigCoverGoUat,
		envConfig: COVERGO_SAAS_PROD
	},
	"yallacompare-prod-studio.quote.hk": {
		appConfig: appConfigCoverGoProd,
		envConfig: COVERGO_SAAS_PROD
	}
}
